module.exports = __webpack_public_path__ + "media/newstyle/images/icon-profile-orange-39edfeb13d8aa7b7c605e3fe89e53ae3.svg";